import {Inject, Injectable, DOCUMENT} from '@angular/core';
import {environment} from '../../../environments/environment';
import {StorageMap} from '@ngx-pwa/local-storage';
import packageJson from '../../../../package.json';


@Injectable({
  providedIn: 'root'
})
export class VersionService {

  version: string = packageJson.version;

  constructor(
    @Inject(DOCUMENT) private doc: Document,
    private storage: StorageMap
  ) {
  }

  async check(): Promise<void> {
    return new Promise(async (resolve) => {

      const appVersion = await this.storage.get('appVersion').toPromise();

      if (
        !appVersion ||
        appVersion !== this.version
      ) {
        if (!environment.production) {
          console.log(`[Cookies] Clear all cookies`);
          console.log(`[Reload] deprecated app version`);
        }
        await this.storage.clear().toPromise();
        await this.storage.set('appVersion', this.version).toPromise();
        this.doc.defaultView.location.reload();
        return;
      }

      resolve(undefined);

    });
  }
}
